<div class="flex h-full w-full flex-row gap-1 pt-2">
  <div class="surface-low flex w-[26rem] flex-col gap-2 rounded-lg p-2">
    <div class="flex flex-row flex-wrap gap-2" #columnsHeader>
      <button mat-flat-button (click)="addColumn()" class="w-full">
        <mat-icon>add</mat-icon>
        {{ 'Aggiungi colonna' | siaTranslate }}
      </button>
      <button
        mat-button
        (click)="sortVisibleColumns()"
        class="w-[calc(50%-0.5rem)]"
      >
        <mat-icon>swap_vert</mat-icon>
        {{ 'Ordina visibili' | siaTranslate }}
      </button>
      <button mat-button (click)="translateAll()" class="w-[calc(50%-0.5rem)]">
        <mat-icon>translate</mat-icon> {{ 'Toggle Traduzioni' | siaTranslate }}
      </button>
      <button mat-button (click)="exportAll()" class="w-[calc(50%-0.5rem)]">
        <mat-icon>calculate</mat-icon>
        {{ 'Toggle Export excel' | siaTranslate }}
      </button>
      <button mat-button (click)="editAll()" class="w-[calc(50%-0.5rem)]">
        <mat-icon>edit_square</mat-icon>
        {{ 'Toggle Modifica' | siaTranslate }}
      </button>
    </div>

    <sia-search-box
      [(searchExp)]="filter"
      surfaceClass="surface-lowest"
    ></sia-search-box>

    <div
      class="flex flex-col gap-2 overflow-y-auto overflow-x-hidden"
      [style]="
        'height: calc(100% - ' + columnsHeader.offsetHeight + 'px - .5rem)'
      "
      cdkDropList
      cdkDropListOrientation="vertical"
      (cdkDropListDropped)="onColumnDrop($event)"
    >
      @for (column of gridConfiguration.cols; track column; let i = $index) {
        @if (column.configurationVisible) {
          <div
            cdkDrag
            class="surface-high flex flex-row items-center gap-1 rounded-lg p-2"
            (click)="selectColumn(column)"
            [class]="selectedColumn == column ? 'bg-secondary-container' : ''"
          >
            @if (!column.isAction) {
              <mat-icon> view_week </mat-icon>
            }
            @if (column.isAction) {
              <mat-icon> grade </mat-icon>
            }
            <sia-check-box [(value)]="column.visible"></sia-check-box>
            <div class="flex flex-grow flex-row items-center gap-1">
              @if (column.isAction && column.actionIcon) {
                <mat-icon>
                  {{ column.actionIcon }}
                </mat-icon>
              } @else {
                <div class="flex w-64 flex-col gap-1">
                  <span class="w-full truncate text-nowrap font-semibold"
                    >{{ column.caption }} &nbsp;</span
                  >
                  <span class="w-full truncate text-nowrap text-xs">
                    {{ column.dataField }}</span
                  >
                </div>
              }
            </div>
            <button
              mat-icon-button
              (click)="deleteColumn(column)"
              class="error"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        }
      }
    </div>
  </div>
  @if (selectedColumn) {
    <sia-mat-grid-configurator-column
      [column]="selectedColumn"
      [dataBaseFields]="dataBaseFields"
      class="block h-full flex-grow overflow-auto"
    ></sia-mat-grid-configurator-column>
  }
</div>
